module.exports = __webpack_public_path__ + "img/melissa-add-sessao.8549094d.png";